import React from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.scss";

export default function Navbar(props) {
  return (
    <div className="nav">
      <h1 className="nav__logo">Kolawole</h1>

      <ul className="nav__menu">
        <li className="nav__item">
          <NavLink
            exact
            to="/"
            className="nav__link"
            activeClassName="nav__link--active"
          >
            Home
          </NavLink>
        </li>
        <li className="nav__item">
          <NavLink
            to="/about"
            className="nav__link"
            activeClassName="nav__link--active"
          >
            About
          </NavLink>
        </li>
        <li className="nav__item">
          <a href="mailto:kolapopoola4@gmail.com " className="nav__link">
            Contact
          </a>
        </li>
        <li className="nav__item">
          <a
            href="https://drive.google.com/file/d/1caPDwYcQmd8UyH6FMJi04SetnE9s5B-K/view?usp=sharing"
            target="_blank"
            rel="noreferrer noopener"
            className="nav__link"
          >
            Resume
          </a>
        </li>
      </ul>
    </div>
  );
}
